module.exports = __webpack_public_path__ + "img/icon-right.cf5ff8f1.svg";